import { render, staticRenderFns } from "./CreateSchemePlanPropertyForm.vue?vue&type=template&id=5014d69c"
import script from "./CreateSchemePlanPropertyForm.vue?vue&type=script&lang=js"
export * from "./CreateSchemePlanPropertyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports